module.exports = __webpack_public_path__ + "img/11-full.fb69c6a9.jpeg";